"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TermsOfServiceStatement;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("span", null, "I agree to the", ' ', /*#__PURE__*/_react.default.createElement("a", {
  target: "_blank",
  href: "/articles/terms/"
}, "Canoe Slalom Entries Terms of Service"), ' ', "and the", ' ', /*#__PURE__*/_react.default.createElement("a", {
  target: "_blank",
  href: "https://stripe.com/connect-account/legal"
}, "Stripe Connected Account Agreement"), ".");
function TermsOfServiceStatement() {
  return _ref;
}